import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { ExtendedTab } from '@hdms/shared/common-types';
import { FeatureToggleService } from '@hdms/shared/util-core';

import { getNavigationTabs } from '../utils';

import { AccessService } from './access.service';

@Injectable({
  providedIn: 'root'
})
export class FavoritesNavigationService {
  constructor(private readonly accessService: AccessService, private readonly ftService: FeatureToggleService) {}

  public getNavigation$(): Observable<ExtendedTab[]> {
    return this.accessService.getData$().pipe(
      map(_ =>
        getNavigationTabs(this.ftService.getToggleById('ldt_enable_headless_company_lists'), this.accessService).map(
          ({ id, label, url }) => ({
            id,
            label,
            url
          })
        )
      )
    );
  }
}
